import React from "react"

import {RouteComponentProps} from "react-router-dom"
import {EpisodePlay} from "components/front/Media/Episode/Play/EpisodePlay"

export const EpisodePlayRoute = (props: RouteComponentProps) => {

  const {match} = props
  const {params} = match
  // @ts-ignore
  const episodeId = params?.id

return <div className="episode-play-route">
    <EpisodePlay id={episodeId} />
  </div>
}